import { RemoteSaveUserData } from '../../../data/usecases/save-user-data/remote-save-userdata'
import { makeAxiosHttpClient } from '../../factories/http/axios-http-client-factory'

export const makeSaveUserData = () => new RemoteSaveUserData('/cotacao/saveUserData?origem=ctp', makeAxiosHttpClient())
